module.exports = __webpack_public_path__ + "static/media/ana.c9c6c089.jpeg";